export * from './src/+state/detail-category.service';
export * from './src/+state/detail-category.models';
